import CurrencyConverter from "src/utils/CurrencyConversionService";
import { availabilityId } from "./reducer";
import * as Validators from "src/utils/validators";
import { getTermFromDate } from "src/utils";
import { toUiCollType } from "src/utils/converting";
import { cloneDeep } from "lodash";

const mapAvailabilityRow = (entry, index) => {
    let row = {
        id: availabilityId(entry),
        Lender: entry.lender?.name,
        lender: entry.lender, // for assemblying request payload
        AvailableQuantity: entry.availableQuantity,
        AvailableRate: entry.availableRate,
        ValueDate: entry.valueDate,
        LoanType: entry.loanType,
        FR: entry.fr,
        Maturity: entry.maturityDate,
        Term: getTermFromDate(entry.valueDate, entry.maturityDate),
        Callable: entry.callable,
        Dividend: entry.dividend,
        Intermediary: entry.intermediary,
        TxType: entry.txType,
    };
    if (entry.security) {
        row.SecurityId = entry.security.isin;
        row.ISIN = entry.security.isin;
        row.BbgCode = entry.security.bbgCode;
        row.Ticker = entry.security.ticker;
        row.Name = entry.security.name;
        row.LocalName = entry.security.localName;
        row.PreviousClose = CurrencyConverter.convertFromCountry(
            entry.security.closingPrice,
            entry.security.country
        ).value();
        row.Country = entry.security.country;
        row.AvailableValue = CurrencyConverter.convertFromCountry(
            entry.security.closingPrice * entry.availableQuantity,
            entry.security.country
        ).value();
        row.security = entry.security; // to take availability
    }
    if (entry.collateralType) {
        const { collType, collCcy } = toUiCollType(entry.collateralType);
        row.CollateralType = collType;
        row.CollateralCCY = collCcy;
    }
    return row;
};
const reduceReqRowIsValid = (isValid, row) =>
    isValid &&
    Validators.isTakeRowValid(row) &&
    Validators.isMarketDataFetched(row.marketData);

export const AvailabilitySelectors = {
    GetAvailabilityList: (state) => {
        return state.Availability.todayAvailability.map(mapAvailabilityRow);
    },
    GetSelected: (state) => state.Availability.selectedAvailability,
    GetRequestRows: (state) => {
        // fix immutability redux error
        return cloneDeep(state.Availability.requestRows);
    },
    IsReadyToSubmit: (state) => true,
    HasMarkitAccess: (state) => state.Availability.hasMarkitAccess,
    AvailabilityTakeIsReady: (state) =>
        state.Availability.requestRows.length &&
        state.Availability.requestRows.reduce(reduceReqRowIsValid, true) &&
        state.Tx.initiate.errors.length === 0 &&
        !state.Tx.initiate.requestSettings.error &&
        !state.Table.isEditingCell,
    GetNeedsToAdvertise: (state) => {
        const requestRows = state.Availability.requestRows;
        const takenNeedIds = state.Availability.takenNeedIds;
        const needsToAdvertise = state.Availability.pastedNeeds.filter(
            (n) => !takenNeedIds.includes(n.id)
        );
        const takenNeeds = state.Availability.pastedNeeds.filter((n) =>
            takenNeedIds.includes(n.id)
        );

        for (let i = 0; i < takenNeeds.length; i++) {
            //compare qty
            const availability = requestRows.filter(
                (r) => r.takenNeedId === takenNeeds[i].id
            );
            if (!availability) {
                needsToAdvertise.push(takenNeeds[i]);
            } else {
                const qty = availability.reduce(
                    (total, v) => v.Quantity + total,
                    0
                );
                if (qty < takenNeeds[i].Quantity) {
                    takenNeeds[i].Quantity = takenNeeds[i].Quantity - qty;
                    needsToAdvertise.push(takenNeeds[i]);
                }
            }
        }
        return needsToAdvertise.sort((a, b) => (a.id < b.id ? -1 : 0));
    },
    GetPastedNeeds: (state) => state.Availability.pastedNeeds,
};
